import script from "./Stock.vue?vue&type=script&setup=true&lang=ts"
export * from "./Stock.vue?vue&type=script&setup=true&lang=ts"

import "./Stock.vue?vue&type=style&index=0&id=2548de8f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2548de8f"]])

export default __exports__